import styled from "styled-components"

export const ContentWrapper = styled.div`
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
`

export const OverviewContainer = styled.div`
  margin-bottom: 40px;
  width: 100%;
  text-align: justify;
`

export const CuricullamContainer = styled.div`
  margin-bottom: 40px;
  width: 100%;
  text-align: justify;
`

export const CurriculumListContainer = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0px;
  padding: 0px;
  width: 100%;
  margin-bottom: 40px;
  text-align: justify;
`

export const List = styled.li`
  display: flex;
  align-items: flex-start;
  transition: all 0.3s ease-in-out;
  margin-bottom: 9px;
  width: 100%;

  p {
    font-family: "Roboto Slab";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 23px;
    letter-spacing: 0.03em;
    color: #555555;
    padding-left: 0px;
    max-width: 100%;
  }

  &:hover {
    transform: translateX(10px);
  }
`

export const Title = styled.h2`
  font-family: "Roboto Slab";
  font-style: normal;
  font-weight: 600;
  font-size: 1.6rem;
  line-height: 46px;
  color: #000000;
  margin-bottom: 25px;

  @media (max-width: 767px) {
    font-size: 30px;
    line-height: 40px;
  }
`

export const TypographyDescription = styled.p`
  font-family: "Roboto Slab";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 23px;
  letter-spacing: 0.03em;
  color: #555555;
  width: 100%;
`

export const InfoCard = styled.ul`
  width: 156px;
  height: 60px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  margin-right: 20px;
`

export const ImgCover = styled.span`
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  flex-shrink: 0;
`

export const ButtonSection = styled.div`
  width: 100%;
  max-width: 340px;

  button {
    background: #007bff;
    color: white;
    padding: 12px 24px;
    font-size: 22px;
    font-weight: 600;
    width: 100%;
    margin-bottom: 20px;
  }
`

export const GoToTopButton = styled.button`
  position: fixed;
  bottom: 30px;
  right: 30px;
  background-color: #003591;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  font-family: "Roboto Slab", serif;
  padding: 12px 20px;
  border: none;
  border-radius: 50px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease-in-out;
  border: 2px solid #ffffffff;

  &:hover {
    background-color: #fbda05;
    color: #003591;
    transform: translateY(-2px);
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.25);
  }

  @media (max-width: 767px) {
    bottom: 20px;
    right: 20px;
    font-size: 14px;
    padding: 10px 16px;
  }
`

/* ---------- TABLE: desktop table, stacked cards on mobile ---------- */
export const TableWrapper = styled.div`
  width: 100%;
  margin-top: 30px;

  /* table shell */
  table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    overflow: hidden;
    border-radius: 14px;
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.08);
    background: #ffffff;
    text-align: left;                 /* ✅ prevent inherited justify */
  }

  th, td {
    padding: 14px 16px;
    font-size: 15px;
    line-height: 1.5;
    vertical-align: top;
    border-bottom: 1px solid #edf0f5;
    text-align: left;                 /* ✅ force left inside cells */
    text-justify: auto;
  }

  th {
    background: #e8eefc;
    color: #0b1e6e;
    font-weight: 700;
    position: sticky;
    top: 0;
    z-index: 1;
  }

  /* zebra rows */
  tbody tr:nth-child(odd) { background: #fafbfe; }
  tbody tr:hover { background: #f5f7ff; }

  /* corner rounding */
  thead tr:first-child th:first-child { border-top-left-radius: 14px; }
  thead tr:first-child th:last-child  { border-top-right-radius: 14px; }
  tbody tr:last-child td:first-child  { border-bottom-left-radius: 14px; }
  tbody tr:last-child td:last-child   { border-bottom-right-radius: 14px; }

  td:first-child strong { font-weight: 700; color: #111827; }

  /* -------- Mobile stacked cards -------- */
  @media (max-width: 768px) {
    table, thead, tbody, th, td, tr { display: block; width: 100%; }
    thead { display: none; }

    tr {
      margin: 16px 0;
      border: 1px solid #e5e7eb;
      border-radius: 14px;
      overflow: hidden;
      background: #ffffff;
      box-shadow: 0 6px 18px rgba(17, 24, 39, 0.06);
    }

    td {
      position: relative;
      border: 0;
      border-bottom: 1px solid #f3f4f6;
      padding: 12px 16px 12px calc(16px + 36%);  /* ✅ single padding (36% gutter) */
      word-break: break-word;
      text-align: left;                           /* ✅ no justify on mobile */
    }

    td::before {
      content: attr(data-label);
      position: absolute;
      top: 12px;
      left: 16px;
      width: 36%;
      font-weight: 700;
      color: #374151;
      padding-right: 8px;
      white-space: nowrap;
    }

    /* first cell as header strip */
    td:first-child {
      padding: 14px 16px;
      background: #eef2ff;
      border-bottom: 1px solid #e5e7eb;
      padding-left: 16px;            /* reset left label gutter */
    }
    td:first-child::before { display: none; }

    /* last cell in card */
    td:last-child { border-bottom: 0; }

    /* hide empty Description rows on mobile */
    td[data-label="Description"]:empty { display: none; }
  }

  /* Desktop-only: visually hide the repeated category cell but keep column layout */
  @media (min-width: 769px) {
    td.dupCategory {
      color: transparent;          /* hide text */
      text-shadow: none;
      pointer-events: none;
      user-select: none;
    }
    td.dupCategory * { visibility: hidden; } /* also hide FeeChip bubble */
  }
`

export const FeeChip = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: .02em;
  background: ${({ $tone }) => ($tone === "after" ? "#fff7ed" : "#eef2ff")};
  color: ${({ $tone }) => ($tone === "after" ? "#9a3412" : "#1e3a8a")};
  border: 1px solid ${({ $tone }) => ($tone === "after" ? "#fdba74" : "#c7d2fe")};
  margin-left: 6px;
  vertical-align: middle;
`;

export const AmountCell = styled.td`
  text-align: right;
  font-variant-numeric: tabular-nums;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;

  @media (max-width: 768px) {
    text-align: left;
  }
`;